import ApiGenerator from '@services/ApiGenerator';

const GET = 'osba/accountAffiliations/GET';
const GET_ERROR = 'osba/accountAffiliations/GET_ERROR';
const GET_RECEIVED = 'osba/accountAffiliations/GET_RECEIVED';
const SAVE = 'osba/accountAffiliations/SAVE';
const SAVE_ERROR = 'osba/accountAffiliations/SAVE_ERROR';
const SAVE_RECEIVED = 'osba/accountAffiliations/SAVE_RECEIVED';

const initialState = {
  Involvement: [],
  loading: false,
  message: '',
  error: '',
};

const mapResponse = data => ({
  Involvement: data.Model.Involvement,
  message: data.Message,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SAVE:
      return {
        ...state,
        ...action.data,
        loading: true,
        error: '',
      };
    case GET_RECEIVED:
    case SAVE_RECEIVED:
      return {
        ...state,
        ...mapResponse(action.data),
        loading: false,
      };
    case GET_ERROR:
    case SAVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const getAffiliationsInfo = () => ({
  type: GET,
});

export const saveAffiliationsInfo = data => ({
  type: SAVE,
  data: {
    Involvement: data.Involvement,
  },
});

export const middleware = () => next => (action) => {
  const api = ApiGenerator(next);

  next(action);

  switch (action.type) {
    case GET:
      api('get', '/Affiliations/Get', GET);
      break;
    case SAVE:
      api('post', '/Affiliations/Save', SAVE, {
        ...action.data,
      });
      break;
    default:
      break;
  }
};

export default reducer;
